import { NipValidator } from "../../common/validators/nip-validator";

export class KsefNumberValidator {
	private static format = /^[0-9]{10}-(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])-.{12}-.{2}$/;

	public static isValid(value: string): boolean {
		const validFormat = this.format.test(value);
		if (!validFormat) return false;

		const nipValid = NipValidator.isValid(value.split('-')[0]);
		if (!nipValid) return false;

		return true;
	}
}
